import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TeamParticipantsComponent } from './team-participants/team-participants.component'
import { TeamDetailsComponent } from './team-details.component';
import { TeamScheduleComponent } from './team-schedule/team-schedule.component';
import { TeamLineupComponent } from './team-lineup/team-lineup.component';
import { TeamAdminsComponent } from './team-admins/team-admins.component';
import { TeamCoachesComponent } from './team-coaches/team-coaches.component';
import { TeamFansComponent } from './team-fans/team-fans.component';
import { DetailsComponent } from './details/details.component';

const routes: Routes = [
    {
        path: '',
        component: TeamDetailsComponent,
        children: [
            {
                path: 'players',
                component: TeamParticipantsComponent
            },
            {
                path: 'schedule',
                component: TeamScheduleComponent
            },
            {
                path: 'details',
                component: DetailsComponent
            },
            {
                path: 'lineup',
                component: TeamLineupComponent
            },
            {
                path: 'staff',
                component: TeamAdminsComponent
            },
            {
                path: 'campaigns',
                loadChildren: () => import('../../campaigns/campaigns.module').then(m => m.CampaignsModule)
            },
            {
                path: 'coaches',
                component: TeamCoachesComponent
            },
            {
                path: 'fans',
                component: TeamFansComponent
            }
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class TeamDetailsRoutingModule { }
